/*
 * @Author: wangbaihe
 * @Date: 2023-07-13 18:13:36
 * @LastEditors: wangbaihe
 * @LastEditTime: 2023-07-25 10:38:54
 * @FilePath: \common-mediax\src\apis\MediaCloudPaperManage\PaperParams.js
 * @Description: 补充报纸设置删除接口
 */
import { createAPI } from '../../common'
// MediaCloudPaperManagePaperParams
export default {
  // 最后五分钟页面获取是否有大样签发权限
  getPresignPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0qsftjho0qfsnjttjpo', 'get', config),
  getGroup: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpogjh0hspvq', 'get', config),
  postConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpogjh', 'post', config),
  deleteConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpogjh', 'delete', config),
  getCheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpogjh0difdl', 'get', config, {
      neverLoading: true
    }),
  postModify: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpogjh0cbudi', 'post', config),
  // 获取配置的岗位信息
  getCheckItems: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpogjh0qptudifdl0jufnt', 'get', config),
  // 保存岗位信息
  postCheckItemSave: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpogjh0qptudifdl0tbwf', 'post', config)
}
